import { Component, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'app-filter-supervisor-submissions-by-day.component',
  templateUrl: './filter-supervisor-submissions-by-day.component.html',
  styleUrls: ['./filter-supervisor-submissions-by-day.component.css']
})
export class FilterSupervisorSubmissionsByDayComponent extends AppComponentBase {

  constructor(injector: Injector) {
    super(injector)
  }

  publishName(name: string): void {
    abp.event.trigger('app.dashboardFilters.supervisorSubmissionsByDayFilter.onNameChange', name);
  }
}
